import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
interface Props {
  label: string;
  value?: string;
  className?: string;
}
export function DetailRow(t0) {
  const $ = _c(10);
  const {
    label,
    value,
    className
  } = t0;
  if (!value) {
    return null;
  }
  let t1;
  if ($[0] !== label) {
    t1 = <p className="w-28 shrink-0 text-neutral-500">{label}</p>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className) {
    t2 = cn("pl-2 text-sm", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2 || $[5] !== value) {
    t3 = <p className={t2}>{value}</p>;
    $[4] = t2;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className="flex">{t1}{t3}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}